"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createMockStoreWrapper = createMockStoreWrapper;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

function createMockStoreWrapper(store) {
  var Wrapper = function Wrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
      store: store
    }, children);
  };

  return Wrapper;
}